module.exports = __webpack_public_path__ + "static/media/veneto-village-17.de174e31.jpg";